export default {
    authSet(state, user) {
        state.user = user;
    },
    authRemove(state) {
        state.user = {};
    }
}
